import React from 'react';

import VisuallyHidden from 'components/VisuallyHidden';
import colors from 'utils/colors';

import * as Styled from './styled';

/**
 * <Stepper /> component single "step" property object type definition
 */
export type StepperItemProps = Styled.ItemProps & {
  /**
   * active index of the stepper
   */
  index: number;
  /**
   * The name for the item of the step
   */
  name: string;
};

function StepperItem({ index, name, mode }: StepperItemProps) {
  return (
    <Styled.ItemContainer>
      <Styled.IconWrapper mode={mode}>
        {' '}
        {mode === 'Past' ? <Styled.CompletedStepWrapper fill={colors.white} /> : index + 1}
      </Styled.IconWrapper>
      <Styled.TextWrapper mode={mode}>
        {name}
        {mode === 'Past' && <VisuallyHidden> - Step completed</VisuallyHidden>}
        {mode === 'Current' && <VisuallyHidden> - Current step</VisuallyHidden>}
      </Styled.TextWrapper>
    </Styled.ItemContainer>
  );
}

export default StepperItem;
